import '../App.css';
import Swal from 'sweetalert2';
import { AiFillDelete } from "@react-icons/all-files/ai/AiFillDelete";
import { useSelector, useDispatch } from 'react-redux';
import {
    updateIndividual,
    deleteRelationship
} from '../features/metadata/MetadataLogic'
import React, { useEffect, useState } from 'react';

export default function ModalOverlayGestionPersonas(props) {

    const dispatch = useDispatch()
    const project = useSelector((state) => state.project)
    const nodos = project.timeLines[props.timeLineID].nodes;

    const relaciones = project.timeLines[props.timeLineID].edges;

    const [selectedIndividual, setSelectedIndividual] = useState(1);

    function handleIndividualChange(event) {
        setSelectedIndividual(event.target.value)
    }

    const [selectedColor, setSelectedColor] = useState();

    function handleColorChange(event) {
        setSelectedColor(event.target.value)
    }

    // ------------------------------------------------------------------------------------------------------------------

    // Define el borde si está Presente o Ausente (switch)
    const [shapeProperties, setShapeProperties] = useState();

    // Status = 0 Presente || 1 Ausente
    const [selectedStatus, setSelectedStatus] = useState();

    function handleStatusChange(event) {
        setShapeProperties(!shapeProperties)
        if (shapeProperties === true) {
            // Ausente
            setSelectedStatus('1')
        } else {
            // Presente
            setSelectedStatus('0')
        }
    }

    // True: Visible, False: invisible (switch)
    const [selectedVisibility, setSelectedVisibility] = useState();

    function handleVisibilityChange(event) {
        setSelectedVisibility(!selectedVisibility)
    }

    function handleDeleteRelationship(id) {
        dispatch(deleteRelationship({ timeLineID: props.timeLineID, id: id }))
    }
    // setSelectedIndividual()
    useEffect(() => {
        relaciones.toReversed().forEach((obj) => {
            if (obj.relType == 'ind_ind')
                return setSelectedIndividual(obj.from)
        });
    }, [])

    useEffect(() => {
        setSelectedColor(nodos[selectedIndividual].color)

        if (nodos[selectedIndividual].status === '0') {
            // Presente
            setSelectedStatus('0')
            setShapeProperties(true)
        } else {
            // Ausente
            setSelectedStatus('1')
            setShapeProperties(false)
        }

        if (nodos[selectedIndividual].hidden) {
            setSelectedVisibility(true)
        } else {
            setSelectedVisibility(false)
        }

    }, [selectedIndividual])

    return (
        <div className="overlay">
            <div className="modalCustomizado">
                <div className="container text-center aling-items-start" >
                    <h2 style={{ fontFamily: "Segoe UI", color: "#232323" }}>Gestionar Individuos del Proyecto</h2>

                    <div className="container-fluid">
                        <div className="row justify-content-center align-items-center g-2">
                            <div className="mt-3">
                                <select className="form-select form-select-md" value={selectedIndividual} onChange={e => handleIndividualChange(e)}>
                                    {
                                        nodos.map((item) => {
                                            if (item.type == 'individual') {
                                                return <option key={item.id} value={item.id}> {item.label}</option>
                                            }
                                        })
                                    }
                                </select>

                            </div>

                            {/* Titulos */}
                            <div className="row justify-content-center align-items-center g-2">
                                <div className="col mt-3">
                                    <h4>Metadatos del individuo</h4>
                                </div>
                                <div className="col mt-3">
                                    <h4>Relaciones</h4>
                                </div>
                            </div>

                            {/* Metadatos */}
                            <div className="col">
                                <div className="row justify-content-start align-items-center mb-3">
                                    <div className="col-md-4">
                                        <label for="Color">Color</label>
                                    </div>
                                    <div className="col-md-5">
                                        <input id="colorP" type="color" value={selectedColor} onChange={handleColorChange} />
                                    </div>
                                </div>
                                <div className="row justify-content-start align-items-center mb-3">
                                    <div className="col-md-4">
                                        <label for="status">Estado</label>
                                    </div>
                                    <div className="col-md-5" style={{ marginLeft: '14%', }}>
                                        <div className="form-check form-switch" style={{ width: "50px" }}>
                                            <input className="form-check-input" type="checkbox" role="switch" checked={shapeProperties} onChange={handleStatusChange} style={{ width: "45px", height: "25px" }} title={(shapeProperties && 'Presente') || 'Ausente'} />
                                        </div>
                                    </div>
                                </div>

                                <div class="row justify-content-start align-items-center mb-3">
                                    <div class="col-md-4">
                                        <label for="visibility">Visibilidad</label>
                                    </div>
                                    <div className="col-md-5" style={{ marginLeft: '14%', }}>
                                        <div className="form-check form-switch" style={{ width: "50px" }}>
                                            <input className="form-check-input" type="checkbox" role="switch" checked={!selectedVisibility} onChange={handleVisibilityChange} style={{ width: "45px", height: "25px" }} title={(selectedVisibility && 'Invisible') || 'Visible'} />
                                        </div>
                                    </div>
                                </div>

                            </div>

                            {/* Relacion, desde hasta y opciones */}
                            <div className="col text-center align-self-start" style={{ minHeight: '270px', maxHeight: '270px', overflowY: 'scroll', overflowX: 'hidden', marginBottom: '10px' }}>
                                <div className="row justify-content-start align-items-center mb-3">

                                    <table className="table caption-top">
                                        <thead>
                                            <tr>
                                                <th scope="col">Desde</th>
                                                <th scope="col">Hasta</th>
                                                <th scope="col">Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody className='table-group-divider'
                                        >
                                            {
                                                relaciones.map((obj) => {
                                                    if (obj.relType == 'ind_ind') {
                                                        if (obj.from == selectedIndividual) {
                                                            return <tr key={obj.id}>
                                                                <td>{nodos[obj.from].label}</td>
                                                                <td>{nodos[obj.to].label}</td>
                                                                <td><button type="button" className="btn btn-danger" title='Eliminar Relación' onClick={() => {
                                                                    handleDeleteRelationship(obj.id)
                                                                }
                                                                }><AiFillDelete /></button></td>
                                                            </tr>
                                                        }
                                                        if (obj.to == selectedIndividual) {
                                                            return <tr key={obj.id}>
                                                                <td>{nodos[obj.from].label}</td>
                                                                <td>{nodos[obj.to].label}</td>
                                                                <td><button type="button" className="btn btn-danger" title='Eliminar Relación' onClick={() => {
                                                                    // Cambiar a arreglo de variables para posterior confirmación
                                                                    // -----
                                                                    handleDeleteRelationship(obj.id)
                                                                }
                                                                }><AiFillDelete /></button></td>
                                                            </tr>
                                                        }
                                                    }
                                                }
                                                )

                                            }
                                        </tbody>
                                    </table>
                                </div>

                            </div>

                        </div>

                    </div>

                    <div className="row justify-content-center align-items-end">
                        <div className="col-2">
                            <button type="button" className="btn btn-primary" onClick={() => {

                                let dispatchData = {
                                    nodeID: selectedIndividual,
                                    color: selectedColor,
                                    status: selectedStatus,
                                    shapeProperties: !shapeProperties,
                                    hidden: selectedVisibility
                                }

                                dispatch(updateIndividual({
                                    timeLineID: props.timeLineID, nodeID: dispatchData.nodeID, color: dispatchData.color,
                                    status: dispatchData.status, shapeProperties: dispatchData.shapeProperties, hidden: dispatchData.hidden
                                }))

                                const Toast = Swal.mixin({
                                    toast: true,
                                    position: 'top-end',
                                    showConfirmButton: false,
                                    timer: 3000,
                                    timerProgressBar: true,
                                    didOpen: (toast) => {
                                        toast.addEventListener('mouseenter', Swal.stopTimer)
                                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                                    }
                                })
                                Toast.fire({
                                    icon: 'success',
                                    title: 'Individuo actualizado con éxito'
                                })
                            }}>Aplicar</button>
                        </div>
                        <div className="col-2">
                            <button onClick={props.onClose} className="btn btn-danger">Cerrar</button>
                        </div>
                    </div>

                </div>

            </div >
        </div >
    );
}

